import type { Terrain } from '../instanceTypes';

export type TerrainOption = Terrain | string;

const countryNames = new Intl.DisplayNames(['fr'], { type: 'region' });

function resolveCountry(code: string): string {
  try {
    return countryNames.of(code) ?? code;
  } catch {
    return code;
  }
}

export function getTerrainLabel(opt: TerrainOption): string {
  if (typeof opt === 'string') return opt;
  const country = resolveCountry(opt.pays);
  const parts = [opt.codeterrain, country];
  if (opt.libelle && opt.libelle.trim()) parts.push(opt.libelle);
  return parts.join(' – ');
}

export function isSameTerrain(opt: TerrainOption, val: TerrainOption): boolean {
  const code = (o: TerrainOption) => (typeof o === 'string' ? o : o.codeterrain);
  return code(opt) === code(val);
}
